import axios from 'axios';
import VoilaConfig from '../config';

export const REQUEST_ORDER_HISTORY = 'REQUEST_ORDER_HISTORY';
export const RECEIVE_ORDER_HISTORY = 'RECEIVE_ORDER_HISTORY';

const REQUEST_HISTORY_URL = `${VoilaConfig.API_URL}/wc/v2/orders`;

function requestHistory() {
  return {
    type: REQUEST_ORDER_HISTORY
  }
}

function receiveOrders(orders) {
  return {
    type: RECEIVE_ORDER_HISTORY,
    items: orders.data,
    receivedAt: Date.now()
  }
}

export function requestOrderHistory(token) {
  return async (dispatch, getState) => {
    dispatch(requestHistory());

    let orders = await axios.get(REQUEST_HISTORY_URL, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return dispatch(receiveOrders(orders));
  };
}



// WEBPACK FOOTER //
// ./src/actions/OrderHistoryActions.js